import { defineMessage } from 'react-intl';

export const LISTING_HEAP_IDS = {
  RELATED_EVENTS_STRING: 'Related Events',
  CAROUSEL_CARD: 'Hero Content - Carousel card - Change',
  CHILD_EVENTS_DROPDOWN: 'Listing - Date - Child Events Dropdown - Click',
  CHECKOUT_BUTTON: 'Conversion Bar - Checkout Button',
  CREATOR_TOP_BANNER_EDIT: 'Creator Top Banner - Edit',
  CTA_RSVP_MAYBE: 'Listing - Conversion Bar - RSVP Maybe - Click',
  CTA_RSVP_NO: 'Listing - Conversion Bar - RSVP No - Click',
  DESCRIPTIVE_ORGANIZER: 'Listing - Descriptive Organizer Panel - Follow - Click',
  EXPLORE_SIMILAR_EVENTS: 'Listing - Conversion Bar - Explore Similar Events - Click',
  FAQS_DROPDOWN: 'FAQs - Dropdown',
  FOLLOW_BUTTON: 'Listing - Follow - Button - Click',
  HERO_VIDEO: 'Promo Video - Play',
  HIDE_MAP: 'Listing - Hide Map - Button - Click',
  IMAGE_CATEGORY_CLICK: 'Listing - Expired Event Page - Click - Category Browse',
  IMAGE_CATEGORY_VIEW: 'Listing - Expired Event Page - View - Category Browse',
  LEFT_ARROW_HERO_CAROUSEL: 'Hero Content - Hero Carousel - Left',
  MAP_DRIVE: 'Listing - Map - Drive - Click',
  MAP_WALK: 'Listing - Map - Walk - Click',
  MAP_BUS: 'Listing - Map - Bus - Click',
  MAP_BIKE: 'Listing - Map - Bike - Click',
  MAP_ZOOM_CHANGE: 'Listing - Map - Zoom - Change',
  MORE_COLLECTIONS_THAT_FEATURE_EVENT: 'More Collections That Feature This Event - View more collections Button',
  MORE_OPTIONS_BUTTON: 'Hero Content - More options button in Repeating events - Click',
  MORE_OPTIONS_CARD: 'Hero Content - More options last card in Repeating events - Click',
  MORE_OPTIONS_DATE: 'Hero Content - Change date confirmation in Calendar - Click',
  ONLINE_EVENT_ACCESS_BUTTON: 'Listing - Online Location - Access the Event - Click',
  ORGANIZER_FACEBOOK: 'Listing - Organizer Panel - Organizer Facebook - Click',
  ORGANIZER_NAME: 'Listing - Organizer Panel - Organizer Name - Click',
  ORGANIZER_TWITTER: 'Listing - Organizer Panel - Organizer Twitter - Click',
  ORGANIZER_WEBSITE: 'Listing - Organizer Panel - Organizer Website - Click',
  ORGANIZER_MORE_EVENTS_VIEW: 'More Events From This Organizer View - View',
  ORGANIZER_MORE_EVENTS_CLICK: 'More Events From This Organizer Event card - Click',
  PART_OF_A_COLLECTION: 'Hero Content - Part of /Featured in Collection/s button',
  RECOMMENDATIONS_VIEW: 'PersonalizedRelatedEventsView',
  LISTING_RELATED_EVENT_CLICK: 'Listing - Related Events - Click - Event Card',
  RIGHT_ARROW_HERO_CAROUSEL: 'Hero Content - Hero Carousel - Right',
  SHARE_EVENT: 'Listing - Hero - Share - Click',
  SHOW_MAP: 'Listing - Show Map - Button - Click',
  SIMPLIFIED_ORGANIZER: 'Listing - Simplified Organizer Panel - Follow - Click',
  UNFOLLOW_BUTTON: 'Listing - Following - Button - Click',
  FOLLOW_ORGANIZER: 'FollowOrganizerClick',
  FOLLOW_ORGANIZER_SUCCESS: 'FollowOrganizerSuccessful',
  UNFOLLOW_ORGANIZER: 'UnfollowOrganizerClick',
  UNFOLLOW_ORGANIZER_SUCCESS: 'UnfollowOrganizerSuccessful',
  HIGHLIGHT_LOCATION_CLICK: 'Highlights - Location anchor - Click',
  HIGHLIGHT_REFUND_CLICK: 'Highlights - Refund Service Info anchor - Click',
  ABOUT_THIS_EVENT_READ_MORE: 'Listings - Description - Read more - Click',
  ABOUT_THIS_EVENT_READ_LESS: 'Listings - Description - Read less - Click',
  TICKETS_ANCHOR_BUTTON_VIEW: 'ListingWeb - Tickets Anchor button - View',
  TICKETS_ANCHOR_BUTTON_CLICK: 'ListingWeb - Tickets Anchor button - Click',
  ABOUT_THIS_EVENT_VIEW: 'ListingWeb - Description - View',
  TICKET_SECTION_VIEW: 'ListingWeb - Ticket Section - View',
  TICKET_CONTROL_SECTION_VIEW: 'ListingWeb - Ticket Section - View Control',
  ORGANIZER_PANEL_INFO_VIEW: 'ListingWeb - Organizer panel section - View',
  ORGANIZER_TRUST_SIGNAL_VIEW: 'ListingWeb - Organizer top component - View', // NOT USED YET
  VIDEO_DURATION: 'ListingWeb - Video Duration',
  VIDEO_PLAYED: 'ListingWeb - Video Played',
  VIEW_RELIEF_RIBBON: 'ListingWeb - View - Relief Ribbon - DANA', // NOT USED YET
  TIMED_ENTRY_ANCHOR_BUTTON_CLICK: 'ListingWeb - Select Date Anchor button - Click', // NOT USED YET
  G2K_VIEW: 'ListingWeb - Good to know - ListingGoodToKnowView - View',
  G2K_VIEW_CARD: 'ListingWeb - Good to know - ListingGoodToKnowViewCard - View',
  G2K_READ_MORE_CLICK: 'ListingWeb - Good to know - ListingGoodToKnowReadMore - Click',
  G2K_VIEW_ALL_CLICK: 'ListingWeb - Good to know - ListingGoodToKnowViewAll - Click',
  FAQ_VIEW: 'ListingWeb - FAQ - View',
  HIGHLIGHTS_VIEW: 'ListingWeb - Good to know - Highlights - View',
  REFUND_POLICY_VIEW: 'ListingWeb - Good to know - RefundPolicy - View',
  ARTIST_WIDGET_VIEW: 'ListingWeb - Artist Widget - View - All',
  CHECK_AVAILABILITY_CLICK: 'ListingWeb - Check Availability - Click', // NOT USED YET
  CONVERSION_BAR_HYDRATE: 'ListingWeb - Conversion Bar - Hydrate - All',
  LIKE_CLICK: 'Hero Content - Like - Click',
  DISLIKE_EVENT_CLICK: 'Hero Content - DislikeEvent - Click',
};

export const LISTING_HEAP_PAGE_AREA_IDS = {
  SIMPLIFIED_ORGANIZER: 'listing-simplified-organizer',
  DESCRIPTIVE_ORGANIZER: 'listing-descriptive-organizer',
  HERO_CONTENT: 'listing-hero-content',
  ORGANIZER_PANEL: 'listing-organizer-panel',
  REMIND_ME_MODAL: 'listing-remind-me-modal',
  EXPIRED_EVENTS_PAGE: 'listing-expired-events-page',
  HYDRATE_FOLLOW_STATUS: 'listing-hydrate-follow-status',
  TOP_SECTION_MODAL: 'listing-top-section-modal', // surfacing rating experiment
  NEW_ORGANIZER_PANEL: 'listing-new-organizer-panel',
};

// Statsig's Events
export const STATSIG_EVENT_NAMES = {
  LISTING_APP_PAGE_VIEW: 'Listing - App - View - Page',
  LISTING_CONVERSION_BAR_CTA_CLICK: 'Listing - conversionBar - Click - CTA',
  LISTING_TICKET_SELECTION_VIEW: 'Listing - Conversion Bar - Ticket Selection - View',
  LISTING_ALL_EVENT_DETAILS_VIEW: 'Listing - All - Click - View All Event Details',
  LISTING_TICKET_SELECTION_CLICK: 'Listing - Conversion Bar - Ticket Selection - Click',
  CHILD_EVENTS_DROPDOWN: 'Listing - Select a date - Change - Child Events Dropdown',
  MORE_OPTIONS_BUTTON: 'Listing - Select a date - Click - More Options Button',
  MORE_OPTIONS_CARD: 'Listing - Select a date - Click - More Options Card',
  CAROUSEL_CARD: 'Listing - Select a date - Click - Carousel card',
  LISTING_MORE_ORGANIZER_EVENT_CLICK: 'Listing - All - Click - More Organizer Event',
  LISTING_MORE_ORGANIZER_EVENT_LIKE: 'Listing - All - Click - More Organizer Event Like',
  LISTING_MORE_ORGANIZER_EVENT_SHARE: 'Listing - All - Click - More Organizer Event Share',
  LISTING_RELATED_EVENT_CLICK: 'Listing - All - Click - Related Event',
  LISTING_RELATED_EVENT_LIKE: 'Listing - All - Click - Related Event Like',
  LISTING_RELATED_EVENT_SHARE: 'Listing - All - Click - Related Event Share',
  LISTING_SUBCATEGORY_CTA_CLICK: 'Listing - Expired Event Page - Click - Category Browse Modal CTA',
  LISTING_FOLLOW_CLICK: 'Listing - All - Click - Follow',
  LISTING_UNFOLLOW_CLICK: 'Listing - All - Click - Unfollow',
  ABOUT_THIS_EVENT_VIEW: 'ListingWeb - Description - View',
  LISTING_ALL_SUCCESS_LIKE_EVENT: 'Listing - All - Success - Like Event',
  LISTING_NIGHTLIFE_EVENT_CLICK: 'Listing - All - Click - Nightlife Event',
  LISTING_NIGHTLIFE_EVENT_LIKE: 'Listing - All - Click - Nightlife Event Like',
  LISTING_NIGHTLIFE_EVENT_SHARE: 'Listing - All - Click - Nightlife Event Share',
  G2K_VIEW: 'ListingWeb - Good to know - ListingGoodToKnowView - View',
  G2K_VIEW_CARD: 'ListingWeb - Good to know - ListingGoodToKnowViewCard - View',
  G2K_READ_MORE_CLICK: 'ListingWeb - Good to know - ListingGoodToKnowReadMore - Click',
  G2K_VIEW_ALL_CLICK: 'ListingWeb - Good to know - ListingGoodToKnowViewAll - Click',
  FAQ_VIEW: 'ListingWeb - FAQ - View',
  HIGHLIGHTS_VIEW: 'ListingWeb - Good to know - Highlights - View',
  REFUND_POLICY_VIEW: 'ListingWeb - Good to know - RefundPolicy - View',
  LISTING_EXPERIMENT_AA_TEST_VIEW: 'Listing - Experiment - View - A/A Test',
};

export const DOM_IDS = {
  RELATED_EVENTS: 'related-events',
  MORE_ORGANIZER_EVENTS: 'more-organizer-events',
};

export enum AffiliateCodes {
  AFF_RELATED_EVENTS_LIVE = 'erellivmlt', // Related events for live source events
  AFF_RELATED_EVENTS_SAME_ORG = 'erelpanelorg', // Related events for the same organizer
  AFF_RELATED_EVENTS_SAME_COLLECTION = 'odclrlmeitc', // Related events in the same collection
  AFF_RELATED_EVENTS_EXPIRED = 'erelexpmlt', // Related events on expired event pages
  AFF_COLLECTIONS_FEATURING_THIS_EVENT = 'odclrlmctfte', // More collections featuring this event
  AFF_SHARE_WEB_MOBILE = 'ebdsshwebmobile', // Web Share API (mobile native share)
  AFF_SHARE_COPY_URL = 'ebdsshcopyurl', // Copy URL button
}

export const MEDIA_QUERIES = {
  DESKTOP_BREAKPOINT: 1440,
  LARGE_UP_BREAKPOINT: 1200, // Large screen breakpoint for desktop layout
  LARGE_UP_CONTENT_EXPAND_WIDTH: 1264, // 1200px, body-max-width + left & right paddings (32px each)
};
export const LISTING_HEAP_SOURCE = 'listings-webapp';

// GA tracking dropdown
export enum GACodes {
  GA_ACTION_APP_LOAD = 'AppLoad',
  GA_ACTION_BOOKMARK_ADD = 'BookmarkEvent',
  GA_ACTION_BOOKMARK_REMOVE = 'UnbookmarkEvent',
  GA_ACTION_CHECKOUT = 'NewListingTicketsClick',
  GA_ACTION_COLLECTIONS_MODAL_LINK_CLICK = 'AllCollectionsModalLinkClick',
  GA_ACTION_COLLECTION_PAGE_LINK_CLICK = 'CollectionPageLinkClick',
  GA_ACTION_CONTACT_ORG_ATTEMPT_EVENT = 'ContactOrgAttempt',
  GA_ACTION_DIRECTIONS = 'Directions',
  GA_ACTION_EDIT_EVENT = 'EditEvent',
  GA_ACTION_MAP_INTERACTION = 'MapInteract',
  GA_ACTION_SHARE_EVENT = 'Share',
  GA_ACTION_REMINDME = 'RemindMeButton',
  GA_ACTION_UNREMINDME = 'TurnOffRemindMeButton',
  GA_ACTION_SHOW_LIKE_GDPR_MODAL = 'ShowLikeGDPRModal',
  GA_ACTION_SOCIAL_LINK_CLICK = 'ViewOrg',
  GA_ACTION_SELECT_DATE_ATTEMPT = 'SelectDateAttempt',
  GA_ACTION_SELECT_DATE = 'SelectDate',
  GA_ACTION_RSVP_LOADED = 'RSVPLoaded',
  GA_ACTION_RSVP_YES_INTENT = 'RSVPYesIntent',
  GA_ACTION_RSVP_MAYBE = 'RSVPMaybe',
  GA_ACTION_RSVP_NO = 'RSVPNo',
  GA_CATEGORY_COLLECTION_CARD = 'collectioncard',
  GA_CATEGORY_CREATOR_COLLECTIONS_LISTING = 'creator-collections-listing',
  GA_CATEGORY_EVENT_CARD = 'eventcard',
  GA_CATEGORY_LISTING = 'listing',
  GA_LABEL_OPEN_MODAL = 'open-modal',
  GA_LABEL_SHELF = 'shelf',
  GA_LABEL_EVENT_DETAILS = 'event-details',
  GA_LABEL_BIKE = 'bicycling',
  GA_LABEL_BUS = 'transit',
  GA_LABEL_CAN_EDIT = 'CanEdit',
  GA_LABEL_CANNOT_EDIT = 'CannotEdit',
  GA_LABEL_DRIVE = 'drive',
  GA_LABEL_WALK = 'walk',
  GA_LABEL_ZOOM = 'zoom-change',
  GA_LABEL_OLD_LISTING_ZOOM = 'old-listing-zoom-change',
  GA_LABEL_FACEBOOK = 'fb',
  GA_LABEL_TWITTER = 'tw',
  GA_LABEL_WEBSITE = 'website',
  GA_LABEL_BOOKMARK_EVENTS_REMINDER_OK = 'LikeGDPRConfirmationOk',
  GA_LABEL_BOOKMARK_EVENTS_REMINDER_NO = 'LikeGDPRConfirmationNo',
  GA_LABEL_SECONDARY = 'secondary',
  GA_LABEL_SERIES_PARENT = 'SelectADate',
  GA_LABEL_RSVP_MAYBE_MSG_SENT = 'RSVPMaybeMessageSent',
  GA_LABEL_RSVP_NO_MSG_SENT = 'RSVPNoMessageSent',
}

// shared and repeated translations
export const VIEW_ALL_MESSAGE = defineMessage({
  id: 'View all',
  defaultMessage: 'View all',
  description: 'View all link text',
});

export const READ_MORE_MESSAGE = defineMessage({
  id: 'Read more',
  defaultMessage: 'Read more',
  description: 'Read more link text',
});

export const MULTIPLE_DATES = defineMessage({
  id: 'Multiple dates',
  defaultMessage: 'Multiple dates',
  description: 'Multiple dates text for series events',
});

export const DONATION_TEXT = defineMessage({
  id: 'Donation',
  defaultMessage: 'Donation',
  description: 'Donation text',
});

export const DIRECT_AFF_CODE = 'oddtdtdirect';
